import React  from 'react'

import {FieldTListGroupHeader2Props} from "../../../render/list/group-2"

export default function FieldDepartment_TListGroupHeader2(props: FieldTListGroupHeader2Props) {
    const value = props.field.getViewValue(props.model)
    const item = props.field._getOption(value)

    return (
        <div className="text ui5-txt-default">
            {item ? item.label : "Not selected"}
        </div>
    )
}